import $ from 'jquery'

const initializeBlock = function ($block) {
  const button = $block.find('.vn-button')
  const content = $block.find('.text-image-simple-block__content')
  const contentWrapper = $block.find(
    '.text-image-simple-block__content-wrapper'
  )

  button.on('click', function () {
    $block.toggleClass('text-image-simple-block--active')
    const isActive = $block.hasClass('text-image-simple-block--active')
    button.prop('disabled', true)

    contentWrapper.animate(
      { height: !isActive ? 100 : content.height() },
      250,
      function () {
        button.prop('disabled', false)
      }
    )
    var dataText = button.attr('data-text')
    var buttonContent = button.find('.vn-a-content').html()
    button.find('.vn-a-content').html(dataText)
    button.attr('data-text', buttonContent)
  })
}

$('.text-image-simple-block--has-more').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-text-image-simple',
    initializeBlock
  )
}
